import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  
  // Check if user has valid token
  if (authService.isAuthenticated()) {
    // Also check if user data exists
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        // Check if user object has required properties (id and email)
        // Email must be non-empty string
        if (user && user.id && user.email && user.email.trim().length > 0) {
          return true; // User is authenticated, allow access
        }
      } catch (error) {
        // Invalid user data, clear all
        authService.clearAll();
      }
    }
  }

  // User is not authenticated, clear all and redirect to home/login page
  authService.clearAll();
  router.navigate(['/home'], { replaceUrl: true });
  return false;
};

